var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoVWcomerciales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 105 105",
    style: {
      enableBackground: "new 0 0 105 105"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#09B0F0;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Rect\\xE1ngulo_126",
    className: "st0",
    d: "M10,0h85c5.5,0,10,4.5,10,10v85c0,5.5-4.5,10-10,10H10c-5.5,0-10-4.5-10-10V10 C0,4.5,4.5,0,10,0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Volkswagen_logo_2019",
    className: "st1",
    d: "M52.1,60.8c-10.3,0-18.6-8.4-18.6-18.7c0-2.1,0.4-4.1,1-6.1l11,21.1 c0.1,0.3,0.3,0.5,0.7,0.5c0.4,0,0.5-0.2,0.7-0.5L52,45.9c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0.1,0.2,0.2l5.1,11.2 c0.2,0.3,0.3,0.5,0.7,0.5s0.5-0.2,0.7-0.5L69.8,36c0.7,2,1.1,4,1.1,6.1C70.8,52.4,62.4,60.7,52.1,60.8z M52.1,37.3 c-0.2,0-0.2-0.1-0.2-0.2l-5.8-12.5c3.9-1.4,8.2-1.4,12.1,0l-5.8,12.5C52.3,37.2,52.3,37.3,52.1,37.3z M46,50.9 c-0.1,0-0.1-0.1-0.2-0.2l-9.5-18.3c1.7-2.7,4-5,6.9-6.6l6.7,14.5c0.2,0.3,0.3,0.4,0.5,0.4h3.5c0.2,0,0.4-0.1,0.5-0.4L61,25.8 c2.8,1.6,5.2,3.8,6.9,6.6l-9.4,18.3c-0.1,0.2-0.2,0.2-0.2,0.2s-0.2-0.1-0.2-0.2l-3.5-8.1c-0.2-0.3-0.3-0.4-0.5-0.4h-3.6 c-0.2,0-0.4,0.1-0.5,0.4l-3.6,8.1C46.2,50.8,46.2,51,46,50.9L46,50.9z M52.1,63.3c11.7,0,21.1-9.5,21.1-21.1 c0-11.7-9.5-21.1-21.1-21.1C40.4,21,31,30.5,31,42.2c0,5.6,2.2,11,6.2,14.9C41.1,61,46.5,63.3,52.1,63.3L52.1,63.3z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M40.3,68.9L38.5,74h-1.3l-1.8-5.1v-0.1h1.1l1.3,4.1h0l1.3-4.1L40.3,68.9L40.3,68.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.4,72.5c0,0.5,0.4,0.8,0.9,0.8c0.4,0,0.8-0.1,1.2-0.2l0.2,0.7c-0.4,0.2-0.9,0.3-1.5,0.3 c-1.3,0-1.9-0.9-1.9-2c0-1,0.6-1.9,1.8-1.9c1.2,0,1.7,0.7,1.7,1.6c0,0.2,0,0.5-0.1,0.7H41.4z M42.9,71.8c0,0,0-0.1,0-0.1 c0-0.4-0.2-0.7-0.8-0.7c-0.5,0-0.8,0.4-0.8,0.9H42.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.1,74v-2.2c0-0.5-0.2-0.7-0.7-0.7c-0.4,0-0.6,0.2-0.8,0.3V74h-1v-5.3h1v2h0c0.2-0.2,0.6-0.4,1.1-0.4 c0.9,0,1.4,0.6,1.4,1.5V74H47.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M49,74v-3.7h1V74H49z M50.7,68.6l-0.8,1h-0.9v-0.1l0.6-1L50.7,68.6L50.7,68.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.8,70.2c0.4,0,0.9,0.1,1.1,0.2l-0.2,0.8c-0.2-0.1-0.5-0.2-0.8-0.2c-0.6,0-1,0.3-1,1.1s0.4,1.1,1,1.1 c0.3,0,0.6-0.1,0.8-0.2l0.2,0.8c-0.2,0.1-0.7,0.2-1.1,0.2c-1.2,0-1.9-0.8-1.9-1.9S51.5,70.2,52.8,70.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.7,70.3v2.2c0,0.5,0.2,0.7,0.6,0.7c0.3,0,0.6-0.2,0.8-0.3v-2.6h1V74h-0.8l-0.1-0.4h0 c-0.2,0.2-0.6,0.5-1.1,0.5c-0.9,0-1.3-0.6-1.3-1.5v-2.3H55.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60,68.7v4.5c0,0.1,0,0.1,0.1,0.1h0.4V74c-0.2,0-0.4,0.1-0.6,0.1c-0.7,0-0.9-0.3-0.9-1.1v-4.3H60z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M63,74.1c-1.3,0-1.9-0.9-1.9-1.9c0-1.1,0.7-1.9,1.9-1.9c1.3,0,1.9,0.9,1.9,1.9C64.9,73.2,64.2,74.1,63,74.1z  M63,73.3c0.5,0,0.9-0.4,0.9-1.1s-0.3-1.1-0.9-1.1c-0.5,0-0.9,0.4-0.9,1.1S62.4,73.3,63,73.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M65.7,73c0.4,0.2,0.8,0.3,1.2,0.3s0.6-0.1,0.6-0.4c0-0.2-0.2-0.3-0.5-0.4l-0.5-0.1c-0.5-0.1-1-0.4-1-1.1 c0-0.7,0.6-1.2,1.5-1.2c0.6,0,0.9,0.1,1.4,0.3l-0.3,0.7c-0.3-0.1-0.7-0.2-1.1-0.2c-0.4,0-0.6,0.1-0.6,0.3c0,0.2,0.2,0.3,0.5,0.4 l0.5,0.1c0.6,0.1,1,0.4,1,1.1c0,0.8-0.6,1.2-1.5,1.2c-0.6,0-1.1-0.1-1.5-0.3L65.7,73z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M33.8,76.7c0.5,0,1,0.1,1.5,0.3L35,77.9c-0.4-0.2-0.8-0.3-1.2-0.3c-0.9,0-1.4,0.7-1.4,1.8 c0,1.1,0.5,1.8,1.4,1.8c0.4,0,0.8-0.1,1.2-0.3l0.3,0.8c-0.5,0.2-1,0.3-1.5,0.3c-1.6,0-2.5-1.1-2.5-2.7 C31.3,77.8,32.1,76.7,33.8,76.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.6,82.1c-1.3,0-1.9-0.9-1.9-1.9c0-1.1,0.7-1.9,1.9-1.9c1.3,0,1.9,0.9,1.9,1.9 C39.6,81.2,38.9,82.1,37.6,82.1z M37.6,81.3c0.5,0,0.9-0.4,0.9-1.1s-0.3-1.1-0.9-1.1c-0.5,0-0.9,0.4-0.9,1.1S37.1,81.3,37.6,81.3z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41.1,78.3l0.1,0.4h0c0.2-0.2,0.6-0.5,1.2-0.5c0.5,0,0.9,0.2,1.1,0.6h0c0.2-0.2,0.6-0.6,1.3-0.6 c0.9,0,1.3,0.6,1.3,1.5V82h-1v-2.2c0-0.5-0.2-0.7-0.6-0.7c-0.4,0-0.6,0.2-0.8,0.3c0,0.1,0,0.2,0,0.3V82h-1v-2.2 c0-0.5-0.2-0.7-0.6-0.7c-0.4,0-0.6,0.2-0.8,0.3V82h-1v-3.7H41.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M48,80.5c0,0.5,0.4,0.8,0.9,0.8c0.4,0,0.8-0.1,1.2-0.2l0.2,0.7c-0.4,0.2-0.9,0.3-1.5,0.3 c-1.3,0-1.9-0.9-1.9-2c0-1,0.6-1.9,1.8-1.9c1.2,0,1.7,0.7,1.7,1.6c0,0.2,0,0.5-0.1,0.7H48z M49.6,79.8c0,0,0-0.1,0-0.1 c0-0.4-0.2-0.7-0.8-0.7c-0.5,0-0.8,0.4-0.8,0.9H49.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M52.1,78.3l0.1,0.4h0c0.1-0.2,0.4-0.6,0.9-0.6c0.1,0,0.3,0,0.4,0l-0.1,0.9c-0.1,0-0.3,0-0.4,0 c-0.4,0-0.7,0.2-0.8,0.4V82h-1v-3.7H52.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M55.8,78.2c0.4,0,0.9,0.1,1.1,0.2l-0.2,0.8c-0.2-0.1-0.5-0.2-0.8-0.2c-0.6,0-1,0.3-1,1.1s0.4,1.1,1,1.1 c0.3,0,0.6-0.1,0.8-0.2l0.2,0.8c-0.2,0.1-0.7,0.2-1.1,0.2c-1.2,0-1.9-0.8-1.9-1.9S54.6,78.2,55.8,78.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.2,76.6c0.4,0,0.6,0.2,0.6,0.6s-0.2,0.6-0.6,0.6c-0.4,0-0.6-0.2-0.6-0.6S57.9,76.6,58.2,76.6z M57.7,82 v-3.7h1V82H57.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M62.8,81.2c0,0.1,0,0.1,0.1,0.1h0.3V82c-0.2,0-0.3,0.1-0.5,0.1c-0.4,0-0.6-0.2-0.7-0.4h0 c-0.2,0.2-0.7,0.5-1.2,0.5c-0.8,0-1.2-0.5-1.2-1.2c0-0.8,0.5-1.2,1.8-1.2h0.5v-0.2c0-0.5-0.4-0.5-0.6-0.5c-0.4,0-0.9,0.1-1.2,0.3 l-0.2-0.8c0.4-0.2,0.9-0.3,1.5-0.3c1.1,0,1.6,0.5,1.6,1.5V81.2z M61.4,80.4c-0.7,0-0.9,0.2-0.9,0.4c0,0.3,0.2,0.4,0.5,0.4 c0.3,0,0.6-0.1,0.8-0.3v-0.6H61.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M64.8,76.7v4.5c0,0.1,0,0.1,0.1,0.1h0.4V82c-0.2,0-0.4,0.1-0.6,0.1c-0.7,0-0.9-0.3-0.9-1.1v-4.3H64.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M66.9,80.5c0,0.5,0.4,0.8,0.9,0.8c0.4,0,0.8-0.1,1.2-0.2l0.2,0.7c-0.4,0.2-0.9,0.3-1.5,0.3 c-1.3,0-1.9-0.9-1.9-2c0-1,0.6-1.9,1.8-1.9c1.2,0,1.7,0.7,1.7,1.6c0,0.2,0,0.5-0.1,0.7H66.9z M68.4,79.8c0,0,0-0.1,0-0.1 c0-0.4-0.2-0.7-0.8-0.7c-0.5,0-0.8,0.4-0.8,0.9H68.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.2,81c0.4,0.2,0.8,0.3,1.2,0.3s0.6-0.1,0.6-0.4c0-0.2-0.2-0.3-0.5-0.4L71,80.5c-0.5-0.1-1-0.4-1-1.1 c0-0.7,0.6-1.2,1.5-1.2c0.6,0,0.9,0.1,1.4,0.3l-0.3,0.7c-0.3-0.1-0.7-0.2-1.1-0.2c-0.4,0-0.6,0.1-0.6,0.3c0,0.2,0.2,0.3,0.5,0.4 l0.5,0.1c0.6,0.1,1,0.4,1,1.1c0,0.8-0.6,1.2-1.5,1.2c-0.6,0-1.1-0.1-1.5-0.3L70.2,81z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoVWcomerciales);
export default __webpack_public_path__ + "static/media/ico_VWcomerciales.3d2a92e0c70ed39722c39c839b8dd232.svg";
export { ForwardRef as ReactComponent };